var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authenticated)?_c('div',{staticClass:"user"},[_c('h3',{staticClass:"user__name"},[_vm._v(_vm._s(_vm.name))]),_c('a',{on:{"click":_vm.logout}},[_vm._v("Вийти")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }